module.exports = __webpack_public_path__ + "process-white-i.png";